import React from 'react';
import Navbar from '@/components/salon/Navbar';
import { Card } from '@/components/ui/card';
import { Cookie, Shield, Settings } from 'lucide-react';

const CookiePolicyPage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-8">
          <div className="flex items-center space-x-3 mb-4">
            <Cookie className="w-8 h-8 text-blue-600" />
            <h1 className="text-4xl font-bold text-slate-900">Cookie-Richtlinie</h1>
          </div>
          <p className="text-slate-600">Letzte Aktualisierung: {new Date().toLocaleDateString('de-DE')}</p>
        </div>

        <Card className="p-8 mb-8">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">Was sind Cookies?</h2>
            <p className="text-slate-700 mb-4">
              Cookies sind kleine Textdateien, die auf Ihrem Gerät gespeichert werden, wenn Sie unsere Website besuchen. Sie helfen uns, die Website zu verbessern und Ihnen ein besseres Nutzererlebnis zu bieten.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">Welche Cookies verwenden wir?</h2>
            
            <div className="space-y-6">
              <div className="border-l-4 border-blue-600 pl-4">
                <h3 className="text-lg font-semibold text-slate-900 mb-2">1. Notwendige Cookies</h3>
                <p className="text-slate-700 mb-2">
                  Diese Cookies sind für die Grundfunktionen der Website erforderlich und können nicht deaktiviert werden.
                </p>
                <ul className="list-disc list-inside text-slate-600 space-y-1 ml-4">
                  <li>Sitzungs-ID für Authentifizierung</li>
                  <li>Cookie-Einwilligung Status</li>
                  <li>Warenkorb-Daten</li>
                  <li>Stripe-Sicherheits- und Zahlungs-Cookies bei Online-Zahlungen</li>
                </ul>
              </div>

              <div className="border-l-4 border-green-600 pl-4">
                <h3 className="text-lg font-semibold text-slate-900 mb-2">2. Funktionale Cookies</h3>
                <p className="text-slate-700 mb-2">
                  Diese Cookies ermöglichen erweiterte Funktionalität und Personalisierung.
                </p>
                <ul className="list-disc list-inside text-slate-600 space-y-1 ml-4">
                  <li>Spracheinstellungen</li>
                  <li>Benutzer-Präferenzen</li>
                  <li>Gespeicherte Formulardaten</li>
                </ul>
              </div>

              <div className="border-l-4 border-purple-600 pl-4">
                <h3 className="text-lg font-semibold text-slate-900 mb-2">3. Analyse-Cookies (Optional)</h3>
                <p className="text-slate-700 mb-2">
                  Diese Cookies helfen uns zu verstehen, wie Besucher unsere Website nutzen.
                </p>
                <ul className="list-disc list-inside text-slate-600 space-y-1 ml-4">
                  <li>Seitenaufrufe und Navigationspfade</li>
                  <li>Verweildauer auf Seiten</li>
                  <li>Technische Informationen (Browser, Gerät)</li>
                </ul>
              </div>

              <div className="border-l-4 border-orange-600 pl-4">
                <h3 className="text-lg font-semibold text-slate-900 mb-2">4. Marketing-Cookies (Optional)</h3>
                <p className="text-slate-700 mb-2">
                  Diese Cookies werden verwendet, um relevante Werbung anzuzeigen.
                </p>
                <ul className="list-disc list-inside text-slate-600 space-y-1 ml-4">
                  <li>Social Media Integration</li>
                  <li>Werbe-Tracking</li>
                  <li>Personalisierte Inhalte</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">Zahlungen über Stripe</h2>
            <p className="text-slate-700">
              Wenn Sie eine Anzahlung, ein Abo oder einen Gutschein kaufen, werden Sie zur sicheren Stripe-Zahlungsseite weitergeleitet. Stripe kann technisch notwendige Cookies zur Betrugsprävention, Authentifizierung und Zahlungsabwicklung setzen. Diese Cookies sind für die gewünschte Zahlung erforderlich.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">Wie lange werden Cookies gespeichert?</h2>
            <div className="bg-slate-50 p-4 rounded-lg">
              <ul className="space-y-2 text-slate-700">
                <li><strong>Sitzungs-Cookies:</strong> Werden gelöscht, wenn Sie Ihren Browser schließen</li>
                <li><strong>Persistente Cookies:</strong> Bleiben für einen festgelegten Zeitraum gespeichert (max. 12 Monate)</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4 flex items-center">
              <Settings className="w-6 h-6 mr-2 text-blue-600" />
              Cookie-Einstellungen verwalten
            </h2>
            <p className="text-slate-700 mb-4">
              Sie können Ihre Cookie-Einstellungen jederzeit ändern:
            </p>
            <ul className="list-disc list-inside text-slate-600 space-y-2 ml-4">
              <li>Über die Cookie-Einstellungen in Ihrem Browser</li>
              <li>Durch Löschen der gespeicherten Cookies in Ihrem Browser</li>
              <li>Über unser Cookie-Banner beim nächsten Besuch</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4 flex items-center">
              <Shield className="w-6 h-6 mr-2 text-blue-600" />
              Ihre Rechte
            </h2>
            <p className="text-slate-700 mb-4">
              Gemäß DSGVO haben Sie folgende Rechte:
            </p>
            <ul className="list-disc list-inside text-slate-600 space-y-2 ml-4">
              <li>Recht auf Auskunft über gespeicherte Daten</li>
              <li>Recht auf Berichtigung falscher Daten</li>
              <li>Recht auf Löschung Ihrer Daten</li>
              <li>Recht auf Einschränkung der Verarbeitung</li>
              <li>Recht auf Datenübertragbarkeit</li>
              <li>Widerspruchsrecht gegen die Verarbeitung</li>
            </ul>
          </section>

          <section className="bg-blue-50 p-6 rounded-lg">
            <h2 className="text-xl font-semibold text-slate-900 mb-3">Kontakt</h2>
            <p className="text-slate-700 mb-2">
              Bei Fragen zu unserer Cookie-Richtlinie kontaktieren Sie uns bitte:
            </p>
            <div className="text-slate-700">
              <p><strong>Herr Galo</strong></p>
              <p>Salon Galo</p>
              <p>Heilermannstr. 6</p>
              <p>45139 Essen</p>
              <p>E-Mail: salongalo@gmx.de</p>
              <p>Telefon: 01636849710</p>
            </div>
          </section>
        </Card>
      </div>
    </div>
  );
};

export default CookiePolicyPage;